const comments = [
  {
    name: '电竞老炮儿',
    time: '3小时前',
    text: '关注51爆料网快一年了，每次转会期的爆料都特别准！上次说的那个战队重组，第二天就官宣了，这消息源是真的硬。51吃瓜爆料每日大赛这个栏目我也天天追，比刷微博有意思多了。',
    likes: '328',
  },
  {
    name: '吃瓜不吐籽',
    time: '5小时前',
    text: '作为一个资深吃瓜群众，51爆料网真的是我的快乐源泉。特别是每日大赛合集，一条一条刷根本停不下来。而且评论区氛围挺好的，不像其他平台全是水军和引战。',
    likes: '256',
  },
  {
    name: '理性围观群众',
    time: '8小时前',
    text: '说实话最早是冲着51爆料每日大赛来的，后来发现这个站的内容覆盖面是真的广。电竞、体育、综艺啥都有，而且更新速度确实快，经常比微博热搜还早一步。希望继续保持！',
    likes: '189',
  },
  {
    name: '深夜码字工',
    time: '12小时前',
    text: '爆料内容质量在同类平台里算上乘的，不是那种标题党。每条都认真写了前因后果，还有编辑的分析点评。不过希望移动端APP能早点上线，有时候在手机上看网页版不太方便。',
    likes: '142',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="section-py bg-background-50">
      <div className="section-container">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-accent-500"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            网友热议
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-lg border border-background-200/70 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 font-semibold text-sm shrink-0">
                  {comment.name.charAt(0)}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="flex items-center gap-1 cursor-pointer hover:text-primary-600 transition-colors">
                  <i className="ri-chat-1-line"></i>
                  回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}